declare namespace $ {

	type $mol_paragraph__title_idle_app_dps_1 = $mol_type_enforce<
		ReturnType< $idle_app_dps['money_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_idle_app_dps_2 = $mol_type_enforce<
		ReturnType< $idle_app_dps['damage_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_row__sub_idle_app_dps_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_paragraph__title_idle_app_dps_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_idle_app_dps_5 = $mol_type_enforce<
		ReturnType< $idle_app_dps['level_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_idle_app_dps_6 = $mol_type_enforce<
		ReturnType< $idle_app_dps['health_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_row__sub_idle_app_dps_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_button_major__title_idle_app_dps_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_idle_app_dps_9 = $mol_type_enforce<
		ReturnType< $idle_app_dps['attack_enemy'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_row__sub_idle_app_dps_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_button_major__title_idle_app_dps_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_idle_app_dps_12 = $mol_type_enforce<
		ReturnType< $idle_app_dps['skill_x10'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_check_box__title_idle_app_dps_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_idle_app_dps_14 = $mol_type_enforce<
		ReturnType< $idle_app_dps['auto_checked'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_row__sub_idle_app_dps_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_button_major__title_idle_app_dps_16 = $mol_type_enforce<
		ReturnType< $idle_app_dps['damage_up_title'] >
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_idle_app_dps_17 = $mol_type_enforce<
		ReturnType< $idle_app_dps['damage_up_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_idle_app_dps_18 = $mol_type_enforce<
		ReturnType< $idle_app_dps['damage_up'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	export class $idle_app_dps extends $mol_page {
		auto_attack( ): any
		money_title( ): string
		Money( ): $mol_paragraph
		damage_title( ): string
		Damage( ): $mol_paragraph
		Stats_row( ): $mol_row
		Enemy( ): $mol_paragraph
		level_title( ): string
		Enemy_level( ): $mol_paragraph
		health_title( ): string
		Enemy_health( ): $mol_paragraph
		Ememy_row( ): $mol_row
		attack_enemy( next?: any ): any
		Attack_enemy( ): $mol_button_major
		Action_row( ): $mol_row
		skill_x10( next?: any ): any
		Dmg_x10( ): $mol_button_major
		auto_checked( next?: boolean ): boolean
		Auto_attack( ): $mol_check_box
		Skills_row( ): $mol_row
		damage_up_title( next?: string ): string
		damage_up_enabled( next?: boolean ): boolean
		damage_up( next?: any ): any
		Damage_up( ): $mol_button_major
		title( ): string
		auto( ): readonly(any)[]
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=dps.view.tree.d.ts.map